package com.gsb.vyapar.bhagya.datasource.network

import kotlinx.serialization.Serializable

@Serializable
data class Dto(
    val v: Int = 0,
    val d: String = "",
)

@Serializable
data class DtoId(
    val v: Int = 0,
    val d: String = "",
    val i: Int = 0,
    val u: String = "",
)
